'use client';
import { fetchErrors } from '@susu/custom-made/app/configurator/fetchErrors';
import Modal from '../modal/modal';
import { ButtonType } from '../button/button';

export default function Error({
  customError,
}: Readonly<{
  customError: string;
}>) {

  return (
    <div>
      <Modal
        isOpen={true}
        title={fetchErrors[customError].title}
        description={fetchErrors[customError].description}
        firstButtonText={fetchErrors[customError].buttonText}
        firstButtonType={ButtonType.Primary}
        onFirstButtonClick={() => {
          fetchErrors[customError].handler();
        }}
        isFullSize={true}
        testId="error-modal"
      />
    </div>
  );
}